@if (currentScaleDenominator) {
  <div class="ggc-scale-denominator">1:{{ currentScaleDenominator }}</div>
}
